<template>
  <div
    :id="videoIdentifier"
    :class="
      'embed-responsive embed-responsive-' +
      ratio +
      ' video-player video-player__button-location--' +
      playPauseLocation
    "
  >
    <div v-nativevideo-load="true">
      <!-- //NOSONAR --><video
        ref="video"
        :autoplay="autoplay"
        :loop="loop"
        :muted="muted"
        playsinline
        preload
        class="embed-responsive-item videolazy"
      >
        <source :data-src="src" :type="type" />
        <label :for="videoIdentifier" class="is-src-only">Video</label>
      </video>
    </div>
    <button
      v-if="playPause"
      type="button"
      class="video-player__button"
      :class="{ 'video-player--playing': playing, 'video-player--paused': !playing }"
      :aria-label="ariaLabel"
      title="play or pause video"
      @click="togglePlay"
    >
      <svg v-if="playing" class="icon icon-stop">
        <use
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="#stop"
        ></use>
      </svg>
      <svg v-if="!playing" class="icon icon-play">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#play"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'videoplayer',
  props: {
    autoplay: { type: Boolean, default: true },
    loop: { type: Boolean, default: true },
    muted: { type: Boolean, default: true },
    src: { type: String, required: true },
    type: { type: String, default: 'video/mp4' },
    playPause: { type: Boolean, default: false },
    playPauseLocation: { type: String, default: 'center' }, // options: top-left, top-right, center, bottom-left. bottom-right
    ratio: { type: String, default: '16by9' }, // options 16by9, 4by3, 1by1, 21by9, 23by9, 47by11
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      playing: this.autoplay,
      videoIdentifier: `video-${Math.random()}`,
    };
  },
  mounted() {
    window.eventBus.$on('videoplay.rejected', () => {
      this.playing = true;
      this.togglePlay();
    });
  },
  methods: {
    togglePlay() {
      if (this.playing) {
        this.$refs.video.pause();
      } else {
        this.$refs.video.play();
      }

      this.playing = !this.playing;
    },
  },
};
</script>
